import React, { Component } from 'react'
import './styles.sass';

export default class SelectedTag extends Component {

  handleClick = () => {
    const {callbackRemoveTag,indexGroup,idTag } = this.props
    if(callbackRemoveTag) callbackRemoveTag(indexGroup,idTag, this.props.multiSelectIndex)
  }

  render() {
    const { tagSelected } = this.props
    //console.log('tagSelected',tagSelected);
    
    return (
      <div className="tag-label">
        <button className="remove" onClick={() => this.handleClick()}></button>
        <span>{tagSelected}</span>
      </div>
    )
  }
}
